<template>
  <div class="main-panel">
    <welcome-top-navbar />
    <main-content></main-content>
    <welcome-content-footer></welcome-content-footer>
  </div>
</template>
<style lang="scss"></style>
<script>
import WelcomeTopNavbar from "./WelcomeTopNavbar.vue";
import WelcomeContentFooter from "./WelcomeContentFooter.vue";
import MainContent from "./Content.vue";
export default {
  components: {
    WelcomeTopNavbar,
    WelcomeContentFooter,
    MainContent
  }
};
</script>
<style scoped>
.main-panel {
  background: rgba(255, 255, 255, 0);
}
.welcome-content-footer{
  position: fixed;
  bottom:0 !important;
}
</style>
